import { toast } from "react-toastify";
import { observable } from "mobx";
import { api } from "../../api";
import { api_adm } from "../../api";

export class _NotificacoesStore {
  obs = observable({
    is_notificacao: false as boolean,
    modulos: [] as any[],
    warnings: [] as any[],
    isTourOpen: false as boolean,
    crons: [] as any[],
  })

  async changeStatusModulo(id: string, checked: boolean) {
    try {
      let data = {
        id: id,
        status: checked
      }

      let resp = await api_adm.post(`/api/admin/modulo/update`, data);

      if (resp.data.ok) {
        toast.success('Status Atualizado!', {});
      } else {
        toast.error('Erro ao atualizar Status.', {});
      }
      await this.handleConsultaModulos()
      await this.handleConsultaWarnings()
    } catch (ex) {
      toast.error("Erro ao alterar Status Modulo, tente novamente mais tarde.", {});
    }
  }

  async handleConsultaModulos() {
    try {
      this.obs.modulos = []

      let resp = await api_adm.get(`/api/admin/modulos/index`);

      this.obs.modulos = resp.data
    } catch (ex) {
      toast.error("Erro ao consultar status modulos, tente novamente mais tarde.", {});
    }
  }

  async handleConsultaWarnings() {
    try {
      this.obs.warnings = []

      let resp = await api.get(`/api/modulos/index-false`);

      this.obs.warnings = resp.data
    } catch (ex) {
      toast.error("Erro ao consultar warnings modulos, tente novamente mais tarde.", {});
    }
  }

  async changeStatusCron(id: string, checked: boolean) {

    try {

      let resp = await api_adm.put(`/api/admin/cron/${id}`, { cron: checked });

      if (resp.data.ok) {

        toast.success(`Cron ${checked ? "LIBERADO" : "BLOQUEADO"} com sucesso!`, {});

        this.handleConsultaCrons()

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao alterar status do Cron, tente novamente mais tarde.", {});
    }

  }

  async handleConsultaCrons() {

    try {

      let resp = await api_adm.get(`/api/admin/crons`);

      this.obs.crons = []
      this.obs.crons = resp.data

    } catch (ex) {

      toast.error("Erro ao consultar status dos Crons, tente novamente mais tarde.", {});

    }

  }

}

export const NotificacoesStore = new _NotificacoesStore();
